import React, {useState, useEffect, useContext, useCallback } from 'react';
import {useParams} from "react-router";
import {APIGetMyOrders} from "../../api/orders/Orders";
import CardGrid from "../../components/cardview/cardGrid";
import {LoadingIndicator} from '../../components/loadingIndicator/loadingIndicator';
import NotFoundMap from "../../assets/map.jpg";
import {ListContext} from "../../context/ListContext";
import { UserContext } from '../../context/UserContext';
import {verifyPermissions} from "../../helper/getProductSettingsHandler";
import { da } from 'date-fns/locale';

export const OrdersIndex = () => {
    const {user, company} = useContext(UserContext);
	const {type} = useParams();
	const [list, setList] = useState(null);
    const [tags, setTags] = useState(null);
    const [openTagSearchModal, setOpenTagSearchModal] = useState(false);

    const settings = {
        all: {
            type:"myOrder",
            title:"Aufträge",
            creationAllowed:verifyPermissions(company, "ordersCreation"),
            creationLabel:"Auftrag erstellen",
            creationType:"order",
            createDialog:{
                image: NotFoundMap,
                text: "Es wurde noch kein Auftrag erstellt."
            },
            deleteDialog:{
                headline:"Auftrag löschen",
                text: "Mit Löschung wird der Auftrag gelöscht sofern dieser noch im Status Entwurf befinden.  Sollte Ihr Auftrag bereits in Vergabe oder sogar in Bearbeitung befinden ist eine Löschung nicht mehr möglich. Der Auftrag kann nur noch Archiviert werden.",
                button: "Endgültig löschen"
            },
            search:{
                searchAllows:verifyPermissions(company, "ordersSearch"),
                searchTags: verifyPermissions(company, "ordersSearchTags"),
                text:"Auftrag",
            },
            actions:{
                orderDelete:verifyPermissions(company, "ordersDelete"),
                orderCreation:verifyPermissions(company, "ordersCreation"),
                orderCounter:verifyPermissions(company, "ordersCounter"),
                orderOpen:true,
                refUpload:false,
                planDownload:false,
                planCreation:false,
                planDelete:false,
                planCertificatedCreate:false,
                planLinkViewer:false,
                mapCreation:false,
                mapDelete:false,
                mapLinkCopy:false,
                mapViewer:false,
                mapLinkViewer:false,
            },
            tableColumns: {
                createdAt:"Erstellt am",
                name:"Name",
                type:"Art",
            },
            tableProgress: "stage"
        }
    }

    const addTagDetails = (data,label) => {
        const response = {
            name: label,
            count: 1
        }

        if(typeof data?.count !== "undefined") {
            response.count = data?.count+1;
        }

        return response;
    };

    const tagGenerator = useCallback((data) => {
        if(data !== null) {
            var tagsCategory = {};
            for(var k =  0; k < data.length; k++) {
                // setup tags for Plan
                data[k]["tags"] = [];

                // Add type per tags
                if(typeof data[k]?.stage !== "undefined") {

                    // Set Tags for Stage
                    if(typeof tagsCategory["stage"] === "undefined") {
                        tagsCategory["stage"] = {
                            name:"Fortschritt",
                            options:{}
                        };
                    }

                    if(data[k]?.stage === "draft") {
                        data[k]["tags"].push("draft");
                        tagsCategory["stage"]["options"]["draft"] = addTagDetails(tagsCategory?.["stage"]?.["options"]?.[data[k]?.stage],"Entwurf");
                    } else if(data[k]?.stage === "inTender") {
                        data[k]["tags"].push("inTender");
                        tagsCategory["stage"]["options"]["inTender"] = addTagDetails(tagsCategory?.["stage"]?.["options"]?.[data[k]?.stage],"In Angebotsphase");
                    } else if(data[k]?.stage === "contracted") {
                        data[k]["tags"].push("contracted");
                        tagsCategory["stage"]["options"]["contracted"] = addTagDetails(tagsCategory?.["stage"]?.["options"]?.[data[k]?.stage],"Beauftragt");
                    } else if(data[k]?.stage === "inDevelopment") {
                        data[k]["tags"].push("inDevelopment");
                        tagsCategory["stage"]["options"]["inDevelopment"] = addTagDetails(tagsCategory?.["stage"]?.["options"]?.[data[k]?.stage],"In Bearbeitung");
                    } else if(data[k]?.stage === "inReview") {
                        data[k]["tags"].push("inReview");
                        tagsCategory["stage"]["options"]["inReview"] = addTagDetails(tagsCategory?.["stage"]?.["options"]?.[data[k]?.stage],"Zur Abnahme");
                    } else if(data[k]?.stage === "completed") {
                        data[k]["tags"].push("completed");
                        tagsCategory["stage"]["options"]["completed"] = addTagDetails(tagsCategory?.["stage"]?.["options"]?.[data[k]?.stage],"Abgeschlossen");
                    }
                }

                // Set Tags for requestedXPlanVersion
                if(typeof data[k]?.planDetails?.requestedXPlanVersion !== "undefined") {

                    if(typeof tagsCategory["requestedXPlanVersion"] === "undefined") {
                        tagsCategory["requestedXPlanVersion"] = {
                            name: "XPlan Version",
                            options: {}
                        };
                    }

                    if(data[k]?.planDetails?.requestedXPlanVersion === "5.0.1") {
                        data[k]["tags"].push("5.0.1");
                        tagsCategory["requestedXPlanVersion"]["options"]["5.0.1"] = addTagDetails(tagsCategory?.["requestedXPlanVersion"]?.["options"]?.[data[k]?.planDetails?.requestedXPlanVersion],"5.0.1");
                    } else if(data[k]?.planDetails?.requestedXPlanVersion === "5.2") {
                        data[k]["tags"].push("5.1.2");
                        tagsCategory["requestedXPlanVersion"]["options"]["5.1.2"] = addTagDetails(tagsCategory?.["requestedXPlanVersion"]?.["options"]?.[data[k]?.planDetails?.requestedXPlanVersion],"5.1.2");
                    } else if(data[k]?.planDetails?.requestedXPlanVersion === "5.3") {
                        data[k]["tags"].push("5.3");
                        tagsCategory["requestedXPlanVersion"]["options"]["5.3"] = addTagDetails(tagsCategory?.["requestedXPlanVersion"]?.["options"]?.[data[k]?.planDetails?.requestedXPlanVersion],"5.3");
                    } else if(data[k]?.planDetails?.requestedXPlanVersion === "5.4") {
                        data[k]["tags"].push("5.4");
                        tagsCategory["requestedXPlanVersion"]["options"]["5.4"] = addTagDetails(tagsCategory?.["requestedXPlanVersion"]?.["options"]?.[data[k]?.planDetails?.requestedXPlanVersion],"5.4");
                    } else if(data[k]?.planDetails?.requestedXPlanVersion === "6.0.2") {
                        data[k]["tags"].push("6.0");
                        tagsCategory["requestedXPlanVersion"]["options"]["6.0.2"] = addTagDetails(tagsCategory?.["requestedXPlanVersion"]?.["options"]?.[data[k]?.planDetails?.requestedXPlanVersion],"6.0.2");
                    }
                }


                // Set Tags for requestedXPlanVersion
                if(typeof data[k]?.planDetails?.planType !== "undefined") {

                    if(typeof tagsCategory["planType"] === "undefined") {
                        tagsCategory["planType"] = {
                            name: "Plan-Art",
                            options: {}
                        };
                    }

                    if(data[k]?.planDetails?.planType?.["developmentPlan"]===true) {
                        data[k]["tags"].push("developmentPlan");
                        tagsCategory["planType"]["options"]["developmentPlan"] = addTagDetails(tagsCategory?.["requestedXPlanVersion"]?.["options"]?.[data[k]?.planDetails?.requestedXPlanVersion],"Bebauungsplan");
                    }
                    if(data[k]?.planDetails?.planType?.["landUsePlan"]===true) {
                        data[k]["tags"].push("landUsePlan");
                        tagsCategory["planType"]["options"]["landUsePlan"] = addTagDetails(tagsCategory?.["requestedXPlanVersion"]?.["options"]?.[data[k]?.planDetails?.requestedXPlanVersion],"Flächennutzungsplan");
                    }
                    if(data[k]?.planDetails?.planType?.["spatialPlanning"]===true) {
                        data[k]["tags"].push("spatialPlanning");
                        tagsCategory["planType"]["options"]["spatialPlanning"] = addTagDetails(tagsCategory?.["requestedXPlanVersion"]?.["options"]?.[data[k]?.planDetails?.requestedXPlanVersion],"Raumordnungplan");
                    }
                    if(data[k]?.planDetails?.planType?.["landscapePlan"]===true) {
                        data[k]["tags"].push("landscapePlan");
                        tagsCategory["planType"]["options"]["landscapePlan"] = addTagDetails(tagsCategory?.["requestedXPlanVersion"]?.["options"]?.[data[k]?.planDetails?.requestedXPlanVersion],"Landschaftsplan");
                    }
                    if(data[k]?.planDetails?.planType?.["otherPlan"]===true) {
                        data[k]["tags"].push("otherPlan");
                        tagsCategory["planType"]["options"]["otherPlan"] = addTagDetails(tagsCategory?.["requestedXPlanVersion"]?.["options"]?.[data[k]?.planDetails?.requestedXPlanVersion],"Sonstiges Planwerk2");
                    }
                }


                // Add type per tags
                if(typeof data[k]?.companiesname !== "undefined") {

                    // Set Tags for Stage
                    if(typeof tagsCategory["creator"] === "undefined") {
                        tagsCategory["creator"] = {
                            name:"Auftragsersteller ",
                            options:{}
                        };
                    }

                    data[k]["tags"].push(data[k]?.companiesname);
                    tagsCategory["creator"]["options"][data[k]?.companiesname] = addTagDetails(tagsCategory?.["creator"]?.["options"]?.[data[k]?.companiesname],data[k]?.companiesname);

                }

                // Add type per tags
                if(typeof data[k]?.planDetails?.community?.name !== "undefined") {

                    // Set Tags for Stage
                    if(typeof tagsCategory["community"] === "undefined") {
                        tagsCategory["community"] = {
                            name:"Gemeinde",
                            options:{}
                        };
                    }

                    data[k]["tags"].push(data[k]?.planDetails?.community?.name);
                    tagsCategory["community"]["options"][data[k]?.planDetails?.community?.name] = addTagDetails(tagsCategory?.["community"]?.["options"]?.[data[k]?.planDetails?.community?.name],data[k]?.planDetails?.community?.name);

                }

                // Add createdByCompanyName per tags
                if(typeof data[k]?.createdByCompanyName !== "undefined") {

                    // Set Tags for Stage
                    if(typeof tagsCategory["createdByCompanyName"] === "undefined") {
                        tagsCategory["createdByCompanyName"] = {
                            name:"Auftraggeber",
                            options:{}
                        };
                    }

                    data[k]["tags"].push(data[k]?.createdByCompanyName);
                    tagsCategory["createdByCompanyName"]["options"][data[k]?.createdByCompanyName] = addTagDetails(tagsCategory?.["createdByCompanyName"]?.["options"]?.[data[k]?.createdByCompanyName],data[k]?.createdByCompanyName);

                }
            }

            setTags(tagsCategory);
        }
        return data;
    }, []);

    const fetchListData = useCallback(async () => {
        const ordersData = await APIGetMyOrders(type, user?.companyId);
        const taggedOrdersData = tagGenerator(ordersData);
        setList(taggedOrdersData);
      }, [tagGenerator, type, user?.companyId]);

    useEffect(() => {
        if (user === undefined) {
            return;
        }

        fetchListData();
    }, [fetchListData, user]);

    const currentSetting = settings?.[(typeof type !== "undefined")? type : "all"];
    const currentUpload =   null;


    return list === null ? (
        <div className='flex w-full h-dvh justify-center items-center'>
            <LoadingIndicator/>
        </div>
    ) : (
        <div className={"mx-auto max-w-7xl"}>
            <main>
                <div className="w-full flex lg:max-h-dvh">
                    <ListContext.Provider value={{list, openTagSearchModal, setOpenTagSearchModal, tags, setList, type, currentSetting, currentUpload, fetchListData}}>
                        <CardGrid/>
                    </ListContext.Provider>
                </div>
            </main>
        </div>
    )

}
